// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import termsEN from '@shared/ui-kit/assets/data/locales/en/terms.md';
import termsES from '@shared/ui-kit/assets/data/locales/es/terms.md';

export const Disclaimer: React.FC = () => {
  const { i18n } = useTranslation();

  const content = useMemo(() => {
    switch (i18n.language) {
      case 'es':
        return termsES;
      default:
        return termsEN;
    }
  }, [i18n.language]);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      className="markdown prose w-full max-w-[calc(100%-30px)] select-text text-copilot-text group-aria-busy:hidden"
      data-testid="aggregation-disclaimer"
    >
      {content}
    </ReactMarkdown>
  );
};
